/**
 * Sprint 47 · Store del Dashboard admin sobre BD real.
 * Sustituye la lectura previa de `ct_boletos_v1` en localStorage.
 */
import { api } from "@/services/api";

export const obtenerKpisDashboard = async () => {
  try {
    const { data } = await api.get("/admin/dashboard/kpis");
    return data;
  } catch (err) {
    return { error: err?.response?.data?.detail || "network" };
  }
};
